// @flow
import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import moment from 'moment';
import numeral from 'numeral';

import type { TMatch, TSquadsById } from '../../modules/types';
import * as selectors from '../../modules/selectors';



const ContainerLink = styled.a`
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	flex-shrink: 0;
	text-decoration: none;
`;

const ContainerDiv = styled.div`
	background: #FFF;
	background: linear-gradient(120deg,
		#FFFFFF 0%, #FFFFFF 50%, #F4F4F4 50%, #FFFFFF 52%, #FFFFFF 100%);
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 185px;
	height: 70px;
	margin-right: 5px;
`;


const SquadFigure = styled.figure`
	margin: 0;
`;

const SquadStats = styled.div`
	width: 25%;
	display: flex;
	align-items: center;
	flex-direction: column;
`;

const SquadLogo = styled.img`
	width: 30px;
`;

const SquadScore = styled.div`
	color: #222;
	&.playing {
		color: #7ED321;
	}
	&.winning {
		font-weight: bold;
	}
`;

const MatchTag = styled.p`
	color: #222;
	font-size: 10px;
	line-height: 1.6;
`;

const LiveTime = styled(MatchTag)`
	font-weight: bold;
	font-size: 12px;
`;

const TimeSpan = styled.span`
	color: #222;
	font-size: 12px;
	text-align: center;
	font-family: RLFont,sans-serif;
	font-weight: 700;
`;

const DateSpan = styled.span`
  color: #222;
	font-size: 10px;
	text-align: center;
	font-family: RLFont,sans-serif;
	font-weight: 400;
`;

const NonTime = styled.p`
	color: #fff;
	background-color: #777;
	border-radius: 0 3px 0 3px;
	width: 60px;
	height: 13px;
	font-size: 9px;
	font-family: RLFont,sans-serif;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 15px auto 3px;
`;

const NonTimeLive = styled(NonTime)`
	background-color: #D0021B;
	width: 30px;
`;

const MatchResults = styled.div`
	width: 33%;
	text-align: center;
  display: flex;
  flex-direction: column;
`;

const matchResults = match => {
	if (match.status === 'scheduled') {
		return (
			<MatchResults>
				<DateSpan>{moment(match.date).format('ddd MMM D')}</DateSpan>
				<TimeSpan>{moment(match.date).format('LT')}</TimeSpan>
			</MatchResults>
		);
	}

	else if (match.status === 'playing') {

		return (
			<MatchResults>
				<NonTimeLive>LIVE</NonTimeLive>
				<LiveTime>
					{match.clock && match.clock.p} | {match.clock &&
							numeral(match.clock.s  / 60).format("0")}:00
				</LiveTime>
			</MatchResults>
		);
	}

	else if (match.status === 'complete') {
		return (
			<MatchResults>
				<NonTime>FULL TIME</NonTime>
				<MatchTag>Match Centre</MatchTag>
			</MatchResults>
		);
	}
};

type Props = {
	match: TMatch,
	squads_by_id: TSquadsById,
	pathname: string,
	selected_draft_league_id: number
}

const url = process.env.REACT_APP_ABSPATH || '';

const MatchPanel = ({ match, squads_by_id, pathname, selected_draft_league_id }: Props) => {

	return (
		<ContainerLink
			id={`M-${match.id}`}
			href={`https:${url}match-centre/${match.round}/${match.id}`}
			target='_blank'>
			<ContainerDiv>
				<SquadStats>
					<SquadFigure>
						<SquadLogo src={`${process.env.REACT_APP_SQUAD_LOGOS_PATH
							+ match.home_squad_id}.png`} alt="NRL club logo"/>
					</SquadFigure>
					<SquadScore
						className={`${match.status === 'playing' ? 'playing' : ''}
						${match.home_score > match.away_score ? 'winning' : ''}`}
					>
						{match.status !== 'scheduled' ? match.home_score : '-'}
					</SquadScore>
				</SquadStats>
				{matchResults(match)}
				<SquadStats>
					<SquadFigure>
						<SquadLogo src={`${process.env.REACT_APP_SQUAD_LOGOS_PATH
							+ match.away_squad_id}.png`} alt="NRL club logo"/>
					</SquadFigure>
					<SquadScore
						className={`${match.status === 'playing' ? 'playing' : ''}
						${match.away_score > match.home_score ? 'winning' : ''}`}
					>
						{match.status !== 'scheduled' ? match.away_score : '-'}
					</SquadScore>
				</SquadStats>
			</ContainerDiv>
		</ContainerLink>
	);
};

const mapStateToProps = state => ({
	squads_by_id: selectors.squads.getSquadsById(state),
	pathname: state.uiMenu.pathname,
	selected_draft_league_id: state.uiSelectedLeague.selected
});

export default connect(mapStateToProps)(MatchPanel);


// WEBPACK FOOTER //
// ./src/components/MatchCentreBar/MatchPanel.js